import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { SpaceFileReadModel, useDeleteSpacesBySpaceIdFilesAndFileIdMutation } from '@client/api';
import { Button, Modal, ModalFooter } from '@client/toolkit';
import { DeleteConfirmationModalContent } from '../../../../components/delete-confirmation-modal-content/delete-confirmation-modal-content';

interface SpaceFileDeleteModalProps {
  spaceFile?: SpaceFileReadModel;
  open: boolean;
  onDeleteFulfilled: () => void;
  onCancel: () => void;
}

export const SpaceFileDeleteModal = ({ spaceFile, open, onCancel, onDeleteFulfilled }: SpaceFileDeleteModalProps) => {
  const { t: tCommon } = useTranslation();
  const { t: tGlobal } = useTranslation('global');

  const [mutation, { isLoading: isDeleting }] = useDeleteSpacesBySpaceIdFilesAndFileIdMutation();

  const id = useMemo(() => spaceFile?.id, [spaceFile?.id]);

  const handleDelete = async () => {
    if (!spaceFile?.spaceId) return;
    if (!spaceFile?.file?.id) return;
    try {
      await mutation({ fileId: spaceFile?.file?.id, spaceId: spaceFile?.spaceId });
    } catch (e) {
      return;
    }
    onDeleteFulfilled();
  };

  const handleClose = () => {
    onCancel();
  };

  useEffect(() => {
    if (!open) return;
    if (id) return;
    onCancel();
  }, [onCancel, open, id]);

  return (
    <Modal open={open} onClose={handleClose} onBackdropClick={handleClose} closeDisabled={isDeleting}>
      <DeleteConfirmationModalContent name={tGlobal('entity.spaceFile')} />
      <ModalFooter className="justify-center">
        <Button color="danger" onClick={handleDelete} progressing={isDeleting} disabled={!id}>
          {tCommon('delete')}
        </Button>
        <Button color="primary-dark" onClick={handleClose}>
          {tCommon('cancel')}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
